module.exports = __webpack_public_path__ + "img/160.3122fe75.jpg";